"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SEVERITY;
(function(SEVERITY) {
  SEVERITY[(SEVERITY["LOW"] = 1)] = "LOW";
  SEVERITY[(SEVERITY["MEDIUM"] = 2)] = "MEDIUM";
  SEVERITY[(SEVERITY["HIGH"] = 3)] = "HIGH";
})((SEVERITY = exports.SEVERITY || (exports.SEVERITY = {})));
exports.getInvalidResponse = message => {
  return { isValid: false, message };
};
exports.getValidResponse = () => {
  return { isValid: true, message: "" };
};
//# sourceMappingURL=IWorkflow.js.map
